import React, { useContext, useState, useEffect } from "react";
import SurveyContext from "../../contexts/SurveyContext";
import { Container, Link } from "./footer.styles";

const Question = ({ setPrivacyShow }) => {
  const isAlreadyAnswered = useContext(SurveyContext).isAlreadyAnswered;
  const [isNewComponent, setIsNewComponent] = useState(false);

  useEffect(() => {
    setIsNewComponent(!isNewComponent);
  }, [isAlreadyAnswered]);

  return (
    <Container isNewComponent={isNewComponent}>
      <Link onClick={() => setPrivacyShow(true)}> למדיניות הפרטיות שלנו</Link>
      &nbsp;- המענה הינו אנונימי לחלוטין
    </Container>
  );
};

export default Question;
